var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
	'panel',
	_vm.margin ? 'panel-margin' : ''
]},[(_vm.loading)?_c('div',{staticClass:"progress-line"}):_vm._e(),_vm._v(" "),(_vm.$slots.title || _vm.$slots.extra)?_c('div',{staticClass:"panel-heading"},[(_vm.$slots.title)?_c('div',{staticClass:"panel-title"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(_vm.$slots.extra)?_c('div',{staticClass:"panel-extra"},[_vm._t("extra")],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('div',{class:[
		!_vm.padding ? 'panel-body' : 'panel-form'
	]},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.$slots.footer)?_c('div',{class:[
		'panel-footer',
		_vm.alt ? 'panel-alt' : ''
	]},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }